<template>
	<div class="tab-template">
		<page-header
			class="tab-template__header"
			route-name="event-ticket-tab-template"
			color-theme="white"
			is-left-button
			is-close
			:title="venueInfo.name"
			@close="navigateToProducts"
		/>
		<main class="tab-template__main">
			<p
				class="tab-template__customer-name"
				:class="{ 'tab-template__customer-name--blank': !customerNameToPrint }"
			>
				{{ customerNameToPrint }}
			</p>
			<img
				:src="placeholderImage"
				class="tab-template__main__placeholder"
				alt="placeholder image"
			/>
		</main>
		<footer class="tab-template__footer">
			<div class="activate-wrapper">
				<primary-button
					large
					fullWidth
					class="activate-btn"
					:rounded="false"
					:disabled="!eventTicketId"
					@click="navigateToEventTicketTab"
				>
					Activate
				</primary-button>
			</div>
		</footer>
	</div>
</template>

<script>
import routerMixin from '@/mixins/routerMixin'

import { mapState } from 'vuex'

import PlaceholderImage from '@/assets/images/ticket-template-placeholder.png'

import PageHeader from '@/components/PageHeader.vue'
import PrimaryButton from '@/components/Buttons/PrimaryButton.vue'

export default {
	name: 'EventTicketTabTemplate',
	mixins: [routerMixin],
	components: {
		PageHeader,
		PrimaryButton
	},
	computed: {
		...mapState('venue', ['venueInfo']),
		...mapState('events', ['eventTicket']),

		placeholderImage() {
			return PlaceholderImage
		},
		customerNameToPrint() {
			return this.$route.query.customerNameToPrint
		},
		eventTicketId() {
			return this.$route.query.eventTicketId
		}
	},
	data() {
		return {}
	},
	methods: {
		async navigateToProducts() {
			await this.goToProducts()
		},
		async navigateToEventTicketTab() {
			await this.goToToEventTicketTab(this.eventTicketId)
		}
	}
}
</script>
<style scoped lang="scss">
@import './src/assets/styles/variables';

.tab-template {
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	background-color: $white;
	color: $grey-dark;

	&__customer-name {
		margin: 15px 0 6px;
		font-size: 14px;

		&--blank {
			width: 150px;
			height: 16px;
			margin-bottom: 16px;
			background-color: rgba($grey-silver-sand, 0.2);
		}
	}

	&__main {
		flex: 1 0 auto;
		padding: 15px 24px;
		width: 100%;
		text-align: left;
		max-width: 502px;
		margin: 0 auto;

		&__placeholder {
			width: 100%;
			// TODO remove temp style for temp screen until new design approved
			max-height: calc(100vh - 370px);
		}
	}

	&__footer {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: auto;
		padding: 24px;
		background-color: $white;
		box-shadow: 0px 0 6px rgba($black, 0.16);

		.activate-wrapper {
			width: 100%;
			max-width: 460px;
			margin: 0 auto;
		}

		.activate-btn {
			font-size: 20px;
		}
	}
}
</style>
